export interface SalesOrderLine {
  id: string;
  orderNo: number;
  lineNo: number;
  customerAccount: string;
  customerName: string;
  customerOrderNo: string;
  customerOrderRef: string;
  crmNo: string;
  dateOrdered: Date;
  orderTypeDescription: string;
  productType: string;
  productKey: string;
  oldCode: string;
  productDescription: string;
  noOfItems: number;
  quantity: number;
  uom: string;
  priceListQty: number;
  cuom: string;
  price: number;
  discount: number;
  deliveryDate: Date;
  delWk: string;
  rqdDespDate: Date;
  currencyCode: string;
  currencyValue: number;
  currencyDiscountValue: number;
  orderLineStatus: string;
  customerRef: string;
  customerLineRef: string;
  reserved: string;
  rsrvExpiry: string;
  regainCondition: number;
  allocateFullPieces: boolean;
  nearestEighth: boolean;
  colour: string;
  commentsExist: boolean;
  confirmed: string;
  stockedProduct: string;
  stockStatus: string;
  subProductStockStatus: string;
}
